import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UdidLabelSchema, UserAppleUdidSchema } from './shapes';

// Label only — a wrong UDID is delete + re-add, so the registration mark never
// has ambiguous "edited after registering" semantics.
export const UpdateAppleUdidBodySchema = z.object({ label: UdidLabelSchema }).strict();
export type UpdateAppleUdidBody = z.infer<typeof UpdateAppleUdidBodySchema>;

export const updateAppleUdid = defineEndpoint({
  method: 'PATCH',
  path: '/v1/apple-udids/:udidId',
  params: z.object({ udidId: z.string().uuid() }),
  query: z.object({}),
  body: UpdateAppleUdidBodySchema,
  response: z.object({ data: UserAppleUdidSchema }),
});
